"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TermFilterUI = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactComponentComponent = _interopRequireDefault(require("react-component-component"));

var _lodash = require("lodash");

require("./FilterContainerStyle.css");

var _common = require("./common");

var _utils = require("../utils");

var _TermAgg = _interopRequireDefault(require("../../Aggs/TermAgg"));

var _TextFilter = _interopRequireDefault(require("../../TextFilter"));

var _utils2 = require("../../SQONView/utils");

var _api = _interopRequireDefault(require("../../utils/api"));

var _config = require("../../utils/config");

var _Query = _interopRequireDefault(require("../../Query"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AggsWrapper = function AggsWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "aggregation-card"
  }, children);
};

var filterStringsCaseInsensitive = function filterStringsCaseInsensitive(values, searchString) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return values.filter(function (val) {
    var valText = path ? (0, _lodash.get)(val, path) : val;
    return -1 !== valText.search(new RegExp(searchString, 'i'));
  });
};

var TermFilterUI = function TermFilterUI(props) {
  var _props$initialSqon = props.initialSqon,
      initialSqon = _props$initialSqon === void 0 ? null : _props$initialSqon,
      _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function (sqon) {} : _props$onSubmit,
      _props$onCancel = props.onCancel,
      onCancel = _props$onCancel === void 0 ? function () {} : _props$onCancel,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? _common.FilterContainer : _props$ContainerCompo,
      _props$InputComponent = props.InputComponent,
      InputComponent = _props$InputComponent === void 0 ? _TextFilter["default"] : _props$InputComponent,
      _props$sqonPath = props.sqonPath,
      sqonPath = _props$sqonPath === void 0 ? [] : _props$sqonPath,
      buckets = props.buckets,
      _props$fieldDisplayNa = props.fieldDisplayNameMap,
      fieldDisplayNameMap = _props$fieldDisplayNa === void 0 ? {} : _props$fieldDisplayNa,
      _props$opDisplayNameM = props.opDisplayNameMap,
      opDisplayNameMap = _props$opDisplayNameM === void 0 ? _utils.FIELD_OP_DISPLAY_NAME : _props$opDisplayNameM,
      field = props.field;
  var initialFieldSqon = (0, _utils.getOperationAtPath)(sqonPath)(initialSqon) || {
    op: _utils.IN_OP,
    content: {
      value: [],
      field: field
    }
  };
  var initialState = {
    searchString: '',
    localSqon: initialSqon
  };

  var onSearchChange = function onSearchChange(s) {
    return function (e) {
      s.setState({
        searchString: e.value
      });
    };
  };

  var isFilterActive = function isFilterActive(s) {
    return function (d) {
      return (0, _utils2.inCurrentSQON)({
        value: d.value,
        dotField: d.field,
        currentSQON: (0, _utils.getOperationAtPath)(sqonPath)(s.state.localSqon)
      });
    };
  };

  var getCurrentFieldOp = function getCurrentFieldOp(s) {
    return (0, _utils.getOperationAtPath)(sqonPath)(s.state.localSqon);
  };

  var onSqonSubmit = function onSqonSubmit(s) {
    return function () {
      return onSubmit(s.state.localSqon);
    };
  };

  var computeBuckets = function computeBuckets(s, buckets) {
    return (0, _lodash.sortBy)(filterStringsCaseInsensitive(buckets, s.state.searchString, 'key'), function (bucket) {
      return !(0, _utils2.inCurrentSQON)({
        value: bucket.key,
        dotField: initialFieldSqon.content.field,
        currentSQON: (0, _utils.getOperationAtPath)(sqonPath)(initialSqon)
      });
    });
  };

  var onOptionTypeChange = function onOptionTypeChange(s) {
    return function (e) {
      var currentFieldSqon = getCurrentFieldOp(s);
      s.setState({
        localSqon: (0, _utils.setSqonAtPath)(sqonPath, _objectSpread(_objectSpread({}, currentFieldSqon), {}, {
          op: e.target.value
        }))(s.state.localSqon)
      });
    };
  };

  var onSelectAllClick = function onSelectAllClick(s) {
    return function () {
      var currentFieldSqon = getCurrentFieldOp(s);
      s.setState({
        localSqon: (0, _utils.setSqonAtPath)(sqonPath, _objectSpread(_objectSpread({}, currentFieldSqon), {}, {
          content: _objectSpread(_objectSpread({}, currentFieldSqon.content), {}, {
            value: filterStringsCaseInsensitive(buckets.map(function (_ref2) {
              var key = _ref2.key;
              return key;
            }), s.state.searchString)
          })
        }))(s.state.localSqon)
      });
    };
  };

  var onClearClick = function onClearClick(s) {
    return function () {
      var currentFieldSqon = getCurrentFieldOp(s);
      s.setState({
        localSqon: (0, _utils.setSqonAtPath)(sqonPath, _objectSpread(_objectSpread({}, currentFieldSqon), {}, {
          content: _objectSpread(_objectSpread({}, currentFieldSqon.content), {}, {
            value: []
          })
        }))(s.state.localSqon)
      });
    };
  };

  var onFilterClick = function onFilterClick(s) {
    return function (_ref3) {
      var generateNextSQON = _ref3.generateNextSQON;
      setTimeout(function () {
        // state change in the same tick somehow results in this component dismounting (probably  something to do with TermAgg's click event, needs investigation)
        var deltaSqon = generateNextSQON();
        var deltaFiterObjContentValue = deltaSqon.content[0].content.value; // we're only interested in the new field operation's content value

        var currentFieldSqon = getCurrentFieldOp(s);
        var existingValue = (currentFieldSqon.content.value || []).find(function (v) {
          return deltaFiterObjContentValue.includes(v);
        });

        var newFieldSqon = _objectSpread(_objectSpread({}, currentFieldSqon), {}, {
          content: _objectSpread(_objectSpread({}, currentFieldSqon.content), {}, {
            value: [].concat(_toConsumableArray((currentFieldSqon.content.value || []).filter(function (v) {
              return v !== existingValue;
            })), _toConsumableArray(existingValue ? [] : deltaFiterObjContentValue))
          })
        });

        s.setState({
          localSqon: (0, _utils.setSqonAtPath)(sqonPath, newFieldSqon)(s.state.localSqon)
        });
      }, 0);
    };
  };

  return /*#__PURE__*/_react["default"].createElement(_reactComponentComponent["default"], {
    initialState: initialState
  }, function (s) {
    return /*#__PURE__*/_react["default"].createElement(ContainerComponent, {
      onSubmit: onSqonSubmit(s),
      onCancel: onCancel
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "contentSection"
    }, /*#__PURE__*/_react["default"].createElement("span", null, fieldDisplayNameMap[initialFieldSqon.content.field] || initialFieldSqon.content.field), ' ', "is", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      className: "select"
    }, /*#__PURE__*/_react["default"].createElement("select", {
      onChange: onOptionTypeChange(s),
      value: getCurrentFieldOp(s).op
    }, _utils.TERM_OPS.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option,
        value: option
      }, opDisplayNameMap[option]);
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contentSection searchInputContainer"
    }, /*#__PURE__*/_react["default"].createElement(InputComponent, {
      value: s.state.searchString,
      onChange: onSearchChange(s)
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contentSection termFilterActionContainer"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "aggsFilterAction selectAll",
      onClick: onSelectAllClick(s)
    }, "Select All"), /*#__PURE__*/_react["default"].createElement("span", {
      className: "aggsFilterAction clear",
      onClick: onClearClick(s)
    }, "Clear")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "contentSection termAggContainer"
    }, /*#__PURE__*/_react["default"].createElement(_TermAgg["default"], {
      WrapperComponent: AggsWrapper,
      field: initialFieldSqon.content.field,
      displayName: "Disease Type",
      buckets: computeBuckets(s, buckets),
      handleValueClick: onFilterClick(s),
      isActive: isFilterActive(s),
      maxTerms: 5
    })));
  });
};

exports.TermFilterUI = TermFilterUI;

var _default = function _default(props) {
  var field = props.field,
      _props$arrangerProjec = props.arrangerProjectId,
      arrangerProjectId = _props$arrangerProjec === void 0 ? _config.PROJECT_ID : _props$arrangerProjec,
      arrangerProjectIndex = props.arrangerProjectIndex,
      _props$api = props.api,
      api = _props$api === void 0 ? _api["default"] : _props$api,
      _props$executableSqon = props.executableSqon,
      executableSqon = _props$executableSqon === void 0 ? {
    op: _utils.AND_OP,
    content: []
  } : _props$executableSqon,
      _props$initialSqon2 = props.initialSqon,
      initialSqon = _props$initialSqon2 === void 0 ? null : _props$initialSqon2,
      _props$onSubmit2 = props.onSubmit,
      onSubmit = _props$onSubmit2 === void 0 ? function (sqon) {} : _props$onSubmit2,
      _props$onCancel2 = props.onCancel,
      onCancel = _props$onCancel2 === void 0 ? function () {} : _props$onCancel2,
      _props$ContainerCompo2 = props.ContainerComponent,
      _ContainerComponent = _props$ContainerCompo2 === void 0 ? _common.FilterContainer : _props$ContainerCompo2,
      _props$InputComponent2 = props.InputComponent,
      InputComponent = _props$InputComponent2 === void 0 ? _TextFilter["default"] : _props$InputComponent2,
      _props$sqonPath2 = props.sqonPath,
      sqonPath = _props$sqonPath2 === void 0 ? [] : _props$sqonPath2,
      _props$fieldDisplayNa2 = props.fieldDisplayNameMap,
      fieldDisplayNameMap = _props$fieldDisplayNa2 === void 0 ? {} : _props$fieldDisplayNa2,
      _props$opDisplayNameM2 = props.opDisplayNameMap,
      opDisplayNameMap = _props$opDisplayNameM2 === void 0 ? _utils.FIELD_OP_DISPLAY_NAME : _props$opDisplayNameM2;

  var gqlField = field.split('.').join('__');
  var query = "query($sqon: JSON){\n    ".concat(arrangerProjectIndex, " {\n      aggregations(filters: $sqon) {\n        ").concat(gqlField, " {\n          buckets {\n            key\n            doc_count\n          }\n        }\n      }\n    }\n  }");
  return /*#__PURE__*/_react["default"].createElement(_Query["default"], {
    variables: {
      sqon: executableSqon
    },
    projectId: arrangerProjectId,
    api: api,
    query: query,
    render: function render(_ref4) {
      var data = _ref4.data,
          loading = _ref4.loading,
          error = _ref4.error;
      return /*#__PURE__*/_react["default"].createElement(TermFilterUI, {
        ContainerComponent: function ContainerComponent(_ref5) {
          var children = _ref5.children,
              props = _objectWithoutProperties(_ref5, ["children"]);

          return /*#__PURE__*/_react["default"].createElement(_ContainerComponent, _extends({}, props, {
            loading: loading
          }), children);
        },
        field: field,
        initialSqon: initialSqon,
        onSubmit: onSubmit,
        onCancel: onCancel,
        InputComponent: InputComponent,
        sqonPath: sqonPath,
        fieldDisplayNameMap: fieldDisplayNameMap,
        opDisplayNameMap: opDisplayNameMap,
        buckets: data ? (0, _lodash.get)(data, "".concat(arrangerProjectIndex, ".aggregations.").concat(gqlField, ".buckets")) : []
      });
    }
  });
};

exports["default"] = _default;